import {
  ButtonTertiary,
  cssColorValue,
  IconPublic,
  screenSmMax,
  semanticColors,
  spacer32,
  Type,
} from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { pathWithoutMarket } from 'utils/market/market';
import { useTranslation } from 'providers/translations/TranslationProvider';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';

const LanguageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer32};
  flex: none;
  order: 1;
  flex-grow: 0;
  @media (max-width: ${screenSmMax}) {
    width: 100%;
    flex: none;
    order: 0;
    flex-grow: 0;
    justify-content: flex-end;
  }
`;

const StyledButton = styled(ButtonTertiary)`
  && {
    color: ${cssColorValue(semanticColors.textSubdued)};
    cursor: pointer;
    &:hover {
      color: ${cssColorValue(semanticColors.textBase)};
    }
  }
`;

const StyledButtonText = styled(Type)`
  margin-left: 2px;
`;

export const FooterLanguage = () => {
  const {
    market: { dir, displayNameWithLanguage },
  } = useServerSideConstants();
  const { t } = useTranslation();
  const marketSelectReturnToPath = pathWithoutMarket(useRouter().asPath);

  const hrefQueryString = marketSelectReturnToPath
    ? `?returnToPath=${encodeURIComponent(marketSelectReturnToPath)}`
    : '';

  const href = `https://www.spotify.com/select-your-country-region/${hrefQueryString}`;

  return (
    <LanguageWrapper>
      <StyledButton
        aria-label={t('change_language_label')}
        data-testid="language-selection-trigger"
        iconLeading={IconPublic}
        dir={dir}
        buttonSize="sm"
        condensedAll
        href={href}
      >
        <StyledButtonText variant="mestoBold">{displayNameWithLanguage}</StyledButtonText>
      </StyledButton>
    </LanguageWrapper>
  );
};
